import React from "react";

/** Shared item-name control for inventory tables/cards (distribution modal trigger). */
export function ClickableInventoryItemName({ item, onItemNameClick }) {
  return (
    <span
      className="clickable-item-name"
      onClick={() => onItemNameClick?.(item)}
    >
      {item.itemName}
    </span>
  );
}
